import React from "react";
import { Database, Sparkles, Boxes, FileSearch2, LayoutTemplate, ArrowUpRight } from "lucide-react";
import { StaggerGroup, StaggerItem } from "@/components/motion/Reveal";
import { SectionContainer, SectionLabel, SectionHeading, SectionLead } from "./SectionPrimitives";

const ITEMS = [
  {
    icon: Database,
    title: "Fahrzeugdaten erfassen",
    desc: "Wir importieren Ihre Bestände aus DMS, IMS und beliebigen Drittquellen — automatisiert, vollständig, mit Versionierung.",
    badge: "01 · Erfassung",
  },
  {
    icon: Boxes,
    title: "Bestände bereinigen & strukturieren",
    desc: "Duplikate, Inkonsistenzen, fehlende Pflichtattribute. Wir vereinheitlichen Ihre Daten auf Google-Vehicle-Ads-Niveau.",
    badge: "02 · Cleansing",
  },
  {
    icon: Sparkles,
    title: "Daten anreichern",
    desc: "Ausstattung, Verbrauchswerte, Bilder-Tags, Fahrzeug-Historie aus unserer eigenen Datenbank — referenziert und prüfbar.",
    badge: "03 · Enrichment",
  },
  {
    icon: FileSearch2,
    title: "Feeds für Google Vehicle Ads",
    desc: "Validierte Merchant-Feeds. Stündliche Synchronisation, Pflichtfeld-Logik, automatische Fehlerkorrektur.",
    badge: "04 · Feed-Ops",
  },
  {
    icon: LayoutTemplate,
    title: "SEO-Landingpages pro Fahrzeug",
    desc: "Aus jeder Fahrzeugzeile entsteht eine indexierbare Landingpage mit Schema.org, internen Links und Conversion-Logik.",
    badge: "05 · SEO-Layer",
  },
];

export default function Leistungsuebersicht() {
  return (
    <SectionContainer id="leistungen">
      <div className="max-w-3xl">
        <SectionLabel number="/ 01" label="Leistungsübersicht" />
        <SectionHeading>Eine Service-Schicht über Ihrem Fahrzeugbestand.</SectionHeading>
        <SectionLead>
          Wir verantworten den gesamten Weg von der Rohdatei bis zur SEO-Landingpage. Sie behalten Ihren Bestand,
          wir liefern Qualität, Sichtbarkeit und Skalierung.
        </SectionLead>
      </div>

      <StaggerGroup className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-6">
        {ITEMS.map((it, idx) => {
          const Icon = it.icon;
          const wide = idx === 0 || idx === 4;
          return (
            <StaggerItem key={it.title} className={wide ? "lg:col-span-3" : "lg:col-span-2"}>
              <article
                data-testid={`leistung-${idx}`}
                className="group h-full rounded-lg border border-slate-200 bg-white p-6 ring-soft transition-all hover:-translate-y-1 hover:border-slate-300 hover:ring-soft-lg sm:p-7"
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex size-10 items-center justify-center rounded-md border border-slate-200 bg-slate-50 text-slate-900 transition-colors group-hover:border-cyan-300">
                    <Icon className="size-4 text-cyan-600" />
                  </span>
                  <span className="label-mono text-slate-400">{it.badge}</span>
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-slate-900 sm:text-xl">
                  {it.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-[15px]">{it.desc}</p>
                <div className="mt-5 inline-flex items-center gap-1.5 text-[12px] font-medium text-cyan-700">
                  Details ansehen <ArrowUpRight className="size-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </article>
            </StaggerItem>
          );
        })}
      </StaggerGroup>
    </SectionContainer>
  );
}
